import { defineMessages } from 'react-intl'

export default defineMessages({
  loading: {
    id: 'data.categories.loading',
    defaultMessage: 'Loading...',
  },
  unknown: {
    id: 'data.categories.unknown',
    defaultMessage: 'Demo',
  },
  advertising: {
    id: 'data.categories.advertising',
    defaultMessage: 'Advertising',
  },
  elearning: {
    id: 'data.categories.elearning',
    defaultMessage: 'eLearning',
  },
  ivr: {
    id: 'data.categories.ivr',
    defaultMessage: 'IVR',
  },
  gaming: {
    id: 'data.categories.gaming',
    defaultMessage: 'Gaming',
  },
  'video-presentation': {
    id: 'data.categories.video-presentation',
    defaultMessage: 'Video presentation',
  },
  technology: {
    id: 'data.categories.technology',
    defaultMessage: 'Technology',
  },
  audiobook: {
    id: 'data.categories.audiobook',
    defaultMessage: 'Audiobook',
  },
  audioguide: {
    id: 'data.categories.audioguide',
    defaultMessage: 'Audio guide',
  },
  podcast: {
    id: 'data.categories.podcast',
    defaultMessage: 'Podcast',
  },
  none: {
    id: 'data.categories.none',
    defaultMessage: 'Demo',
  },
  advertisingURL: {
    id: 'data.categories.advertising.url',
    defaultMessage: 'advertising',
  },
  elearningURL: {
    id: 'data.categories.elearning.url',
    defaultMessage: 'elearning',
  },
  ivrURL: {
    id: 'data.categories.ivr.url',
    defaultMessage: 'ivr',
  },
  gamingURL: {
    id: 'data.categories.gaming.url',
    defaultMessage: 'gaming',
  },
  'video-presentationURL': {
    id: 'data.categories.video-presentation.url',
    defaultMessage: 'video-presentation',
  },
  technologyURL: {
    id: 'data.categories.technology.url',
    defaultMessage: 'technology',
  },
  audiobookURL: {
    id: 'data.categories.audiobook.url',
    defaultMessage: 'audiobook',
  },
  audioguideURL: {
    id: 'data.categories.audioguide.url',
    defaultMessage: 'audioguide',
  },
  podcastURL: {
    id: 'data.categories.podcast.url',
    defaultMessage: 'podcast',
  },
})
